import { z } from 'zod';

import { positionDtoSchema } from '../position-geocode/position.dto.schema';

export const externalInvitationDtoSchema = z.object({
  id: z.number(),
  email: z.string(),
  name: z.string(),
  sector: z.string(),
  projectId: z.string(),
  organisationId: z.number(),
  code: z.string(),
  active: z.boolean(),
  expirationDate: z.string().nullable(),
  eventPosition: positionDtoSchema.nullable(),
  title: z.string().nullable(),
  scope: z.string().nullable(),
  scopeUrl: z.string().nullable(),
  completion: z.string(),
  score: z.string().nullable(),
  status: z.string(),
  isValidated: z.boolean(),
  createdAt: z.string(),
  projectName: z.string(),
  projectImage: z.string().nullable(),
  projectStartDate: z.string().nullable(),
  projectEndDate: z.string().nullable(),
});

export const getExternalInvitationsDtoSchema = z.object({
  data: z.array(externalInvitationDtoSchema),
  limit: z.number(),
  skip: z.number(),
  total: z.number(),
});

export type ExternalInvitationDto = z.infer<typeof externalInvitationDtoSchema>;
